import { API } from "service/Interceptor";

/** Prefer list industry, else company category names from the jobs list DTO. */
export const withIndustryFallback = (job) => {
  if (!job) return job;
  if (Array.isArray(job.industry) && job.industry.length) return job;
  const names = job?.companyJobRespDto?.categoryNames;
  if (Array.isArray(names) && names.length) {
    return { ...job, industry: names };
  }
  const cats = job?.category;
  if (Array.isArray(cats) && cats[0]?.name) {
    return { ...job, industry: cats.map((c) => c.name).filter(Boolean) };
  }
  if (cats?.name) return { ...job, industry: [cats.name] };
  return job;
};

/**
 * List endpoint omits description / budget / industry on QA.
 * Pull full job details so Open briefs cards match creator brief tiles.
 */
export const enrichJobBrief = async (job) => {
  if (!job?.jobId || job.isCreatorBrief) return withIndustryFallback(job);
  if (String(job.jobId).startsWith("post-")) return withIndustryFallback(job);

  const hasDesc = !!String(job.description || "").trim();
  const hasBudget = job.projectBudget != null && job.projectBudget !== "";
  const hasIndustry =
    (Array.isArray(job.industry) && job.industry.length > 0) ||
    (Array.isArray(job?.companyJobRespDto?.categoryNames) &&
      job.companyJobRespDto.categoryNames.length > 0);

  if (hasDesc && hasBudget && hasIndustry) {
    return withIndustryFallback(job);
  }

  try {
    const res = await API.get(`api/jobs/${job.jobId}`, { skipErrorToast: true });
    const d = res?.data?.data;
    if (!d) return withIndustryFallback(job);

    const industry =
      (Array.isArray(d.industry) && d.industry.length && d.industry) ||
      (Array.isArray(d.category) &&
        d.category.map((c) => c?.name).filter(Boolean)) ||
      job.industry;

    return withIndustryFallback({
      ...job,
      description: d.description || job.description,
      applicationsClosed:
        d.applicationsClosed === true || job.applicationsClosed === true,
      projectBudget: d.projectBudget ?? job.projectBudget,
      industry,
      skillsRequired: d.skillsRequired?.length
        ? d.skillsRequired
        : job.skillsRequired,
      cityName: d.cityName || d.city?.name || job.cityName,
      stateName: d.state?.name || job.stateName,
      category: Array.isArray(d.category)
        ? d.category[0] || job.category
        : d.category || job.category,
      // Keep list start/end as listing window; project dates come from description.
    });
  } catch {
    return withIndustryFallback(job);
  }
};

export const enrichJobBriefs = async (jobs = []) =>
  Promise.all((jobs || []).map((job) => enrichJobBrief(job)));
